import React from "react";
import { connect } from "react-redux";

import {
	ThumbnailImg,
	SuggestedVideoContainer,
	VideoTitle,
	VideoDescriptionContainer,
	LockOverlay,
	ThumbnailContainer,
	LockImg,
} from "./suggested-video.styles";
import DifficultyLabel from "../difficulty/difficulty.component";
import IsNewIcon from "../is-new-icon/is-new-icon.component";
import { Link } from "react-router-dom";
import { setCurrentLesson } from "../../redux/lessons/lessons.actions";
import Lock from "../../assets/lock.png";
import { showAlertAction } from "../../redux/alert/alert.actions";

const SuggestedVideo = props => {
	const {
		ThumbnailURL,
		Title,
		Difficulty,
		DocID,
		isAvailable,
		isFree,
		isLocked,
		GermanVersionURL,
	} = props;
	const currentLesson = {
		ThumbnailURL,
		Title,
		Difficulty,
		Date: props.Date || { seconds: 0 },
		DocID,
		isAvailable,
		isFree,
		GermanVersionURL,
	};
	const { setCurrentLesson, showAlert } = props;
	const weekAgo = Date.now() / 1000 - 604800;

	//if I set the cell in to a function the app will scroll to the top when loading more lessons
	const SuggestedVideoCell = () => (
		<SuggestedVideoContainer>
			<ThumbnailContainer>
				<ThumbnailImg src={ThumbnailURL} alt="thumbnail" />
				{isLocked ? (
					<LockOverlay>
						<LockImg src={Lock} alt="lock"></LockImg>
					</LockOverlay>
				) : null}
			</ThumbnailContainer>
			<VideoTitle>{Title}</VideoTitle>
			<VideoDescriptionContainer>
				<DifficultyLabel
					difficulty={Difficulty}
					id={"suggested-video-id"}
				/>
				<IsNewIcon
					isNew={
						(currentLesson.Date || { seconds: 0 }).seconds >=
						weekAgo
					}
				/>
			</VideoDescriptionContainer>
		</SuggestedVideoContainer>
	);

	if (isLocked) {
		return (
			<div
				onClick={() => {
					if (props.match.path === "/previous-lessons") {
						showAlert({
							title: "VIP",
							description:
								"Only VIP members can access this content.",
						});
						//maybe i can delete this alert above
					} else {
						showAlert({
							title: "BASIC or VIP",
							description:
								"Only BASIC or VIP members can access this content.",
							redirectTo: "/subscriptions",
						});
					}
				}}
			>
				<SuggestedVideoCell />
			</div>
		);
	} else {
		return (
			<Link
				to={`/videos/${DocID}`}
				onClick={() => {
					setCurrentLesson(currentLesson);
				}}
			>
				<SuggestedVideoCell />
			</Link>
		);
	}
};

const mapDispatchToProps = dispatch => ({
	setCurrentLesson: currentLessonToSet =>
		dispatch(setCurrentLesson(currentLessonToSet)),
	showAlert: alert => dispatch(showAlertAction(alert)),
});

export default connect(null, mapDispatchToProps)(SuggestedVideo);
